import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const ActionBarContainer = styled.div`
  display: none;

  ${theme.breakpoints.down('md')} {
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    box-shadow: 0px -1px 1px 0px rgba(0, 0, 0, 0.1);
    z-index: 100;
    padding: 0;
  }
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
`

export const ListItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 8px 0;
  width: 100%;
`

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  width: 100%;
`

export const TotalLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #262626;
`

export const TotalValue = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #262626;
  text-align: right;
`

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 16px;
  width: 100%;
`

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #262626;
`

export const DetailLabel = styled.span``

export const DetailValue = styled.span`
  text-align: right;
`

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  width: 100%;
`

export const AcceptButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  height: 40px;
  padding: 8px 16px;
  background: #0273ff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #0260d9;
  }

  &:active {
    background: #0250b8;
  }

  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
`

export const ButtonText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: white;
`

export const BottomSpacer = styled.div`
  height: 4px;
  width: 100%;
`

export const HomeIndicator = styled.div`
  display: flex;
  justify-content: center;
  padding: 21px 0 8px;
  width: 100%;
`

export const HomeIndicatorBar = styled.div`
  width: 135px;
  height: 5px;
  background: black;
  border-radius: 100px;
`
